import PropTypes from 'prop-types'
import { useState, useEffect, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { withValidador } from '../hoc/withValidador'
import * as fetchLocalidadesAPI from '../servicios/fetchLocalidadesAPI'
import Input from '../ui/Input'

const FormInsertDomicilio = (props) => {
  const [errores, setErrores] = useState({})
  const [warnings, setWarnings] = useState({})
  const navigate = useNavigate()
  const [state, setState] = useState({
    idUsuario: parseInt(localStorage.getItem('idUsuario')),
    tipoDomicilio: '',
    domicilioPrincipal: false,
    domicilioFacturacion: false,
    calle: '',
    calleAltura: '',
    piso: '',
    departamento: '',
    idProvincia: 0,
    idLocalidad: 0,
    provincia: '',
    localidad: '',
    ciudad: '',
    cp: '',
    anotaciones: '',
    borrado: false,
    localidadesAPI: []
  })

  const esquemaError = {
    tipoDomicilio: props.Validador.Kernel.string()
      .trim()
      .required()
      .error((e) => {
        return props.Validador.mensaje(e, {
          'any.empty': <>Ups, te olvidaste de completar el Nombre de domicilio!</>
        })
      }),
    calle: props.Validador.Kernel.string()
      .trim()
      .required()
      .error((e) => {
        return props.Validador.mensaje(e, {
          'any.empty': <>Ups, te olvidaste de completar la calle!</>
        })
      }),
    calleAltura: props.Validador.Kernel.string()
      .trim()
      .required()
      .error((e) => {
        return props.Validador.mensaje(e, {
          'any.empty': <>Ups, te olvidaste de completar la altura de la calle!</>
        })
      }),
    cp: props.Validador.Kernel.string()
      .trim()
      .required()
      .error((e) => {
        return props.Validador.mensaje(e, {
          'any.empty': <>Ups, te olvidaste de completar el código postal!</>
        })
      })
  }

  const esquemaWarning = {
    calleAltura: props.Validador.Kernel.number()
      .empty('')
      .error((e) => {
        return props.Validador.mensaje(e, {
          'number.base': <>Ingresaste una Altura no numérica</>
        })
      })
  }

  useEffect(() => {
    if (props.domicilioPrincipal !== state.domicilioPrincipal) {
      setState((prevState) => ({
        ...prevState,
        domicilioPrincipal: props.domicilioPrincipal
      }))
    }
    if (props.domicilioFacturacion !== state.domicilioFacturacion) {
      setState((prevState) => ({
        ...prevState,
        domicilioFacturacion: props.domicilioFacturacion
      }))
    }
  }, [
    props.domicilioPrincipal,
    props.domicilioFacturacion,
    state.domicilioPrincipal,
    state.domicilioFacturacion
  ])

  const formValido = useCallback(() => {
    const erroresValidacion = props.Validador.validarForm(esquemaError, {
      tipoDomicilio: state.tipoDomicilio,
      calle: state.calle,
      calleAltura: state.calleAltura,
      cp: state.cp
    })

    setErrores(erroresValidacion || {})

    if (erroresValidacion) {
      props.Validador.foco()
      return false
    }
    return true
  }, [state, props.Validador, esquemaError])

  const handleSubmit = (e, accion) => {
    e.preventDefault()
    submit(accion)
  }

  const submit = useCallback(
    async (accion) => {
      if (accion === 'grabar') {
        if (!formValido()) {
          return
        }
        props.onNew(state)
      } else if (accion === 'cancelar' && !props.onCancel) {
        navigate('/Perfil')
      } else {
        if (props.onCancel) {
          props.onCancel()
        }
      }
    },
    [state, props, formValido]
  )

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target

    setState((prevState) => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }))

    // Validate field after state update
    setTimeout(() => validarCampo(name), 0)
  }

  const validarCampo = useCallback(
    (name) => {
      const erroresValidacion = props.Validador.validarDato(
        esquemaError,
        {
          tipoDomicilio: state.tipoDomicilio,
          calle: state.calle,
          calleAltura: state.calleAltura,
          cp: state.cp
        },
        name
      )
      setErrores(erroresValidacion || {})

      const warningsValidacion = props.Validador.validarDato(
        esquemaWarning,
        {
          calleAltura: state.calleAltura
        },
        name
      )
      setWarnings(warningsValidacion || {})
    },
    [state, props.Validador, esquemaError, esquemaWarning]
  )

  const handleChangeLocalidad = (e) => {
    const localidad = e.target.value
    setState((prevState) => ({
      ...prevState,
      localidad,
      ciudad: localidad
    }))
  }

  const handleProvincia = async (e) => {
    const provincia = e.target.value
    setState((prevState) => ({ ...prevState, provincia }))

    const request = new Request(
      `https://apis.datos.gob.ar/georef/api/localidades?provincia=${provincia}&max=1000`
    )

    try {
      const resp = await fetch(request)
      const data = await resp.json()
      if (!data.errores) {
        let localidadesAPI = data.localidades
        localidadesAPI = localidadesAPI.map((l) => l.nombre)
        setState((prevState) => ({ ...prevState, localidadesAPI }))
      } else {
        const buscarLocalidadesEBM = async () => {
          const { data: localidades } =
            await fetchLocalidadesAPI.buscarLocalidadesEnEBM(provincia)
          setState((prevState) => ({ ...prevState, localidadesAPI: localidades }))
        }
        buscarLocalidadesEBM()
      }
    } catch {
      const buscarLocalidadesEnEBM = async () => {
        const { data: localidades } =
          await fetchLocalidadesAPI.buscarLocalidadesEnEBM(provincia)
        setState((prevState) => ({ ...prevState, localidadesAPI: localidades }))
      }
      buscarLocalidadesEnEBM()
    }
  }

  return (
    <form className="form-datos-perfil mt-2 mb-4">
      <b className="titulo-domicilio mb-2 mt-2">Domicilio:</b>
      <label htmlFor="tipoDomicilio">Nombre Domicilio</label>
      <Input
        type="text"
        name="tipoDomicilio"
        value={state.tipoDomicilio}
        onChange={handleChange}
        className="input-text-bordered"
        placeholder="Ingrese el nombre del domicilio"
        errores={errores}
      />
      <div>
        <input
          type="checkbox"
          name="domicilioPrincipal"
          checked={state.domicilioPrincipal}
          onChange={(e) => props.onChangeDomicilio(e, 0)}
        />
        <label htmlFor="">Marcar como Domicilio Principal.</label>
      </div>
      <div>
        <input
          type="checkbox"
          name="domicilioFacturacion"
          checked={state.domicilioFacturacion}
          onChange={(e) => props.onChangeDomicilio(e, 0)}
        />
        <label htmlFor="">Marcar como Domicilio de Facturación.</label>
      </div>

      <hr className="hr-perfil w-80"></hr>

      <label htmlFor="">Calle: </label>
      <Input
        type="text"
        name="calle"
        value={state.calle}
        onChange={handleChange}
        className="input-text-bordered"
        placeholder="Ingrese la calle"
        errores={errores}
      />

      <label htmlFor="">Altura</label>
      <Input
        type="text"
        name="calleAltura"
        value={state.calleAltura}
        onChange={handleChange}
        className="input-text-bordered"
        placeholder="Ingrese la altura"
        errores={errores}
        warnings={warnings}
      />

      <label htmlFor="">Piso</label>
      <Input
        type="text"
        name="piso"
        value={state.piso}
        onChange={handleChange}
        className="input-text-bordered"
        placeholder="Ingrese el piso"
      />

      <label htmlFor="">Departamento o Casa</label>
      <Input
        type="text"
        name="departamento"
        value={state.departamento}
        onChange={handleChange}
        className="input-text-bordered"
        placeholder="Ingrese el departamento o casa"
      />

      <label htmlFor="">Provincia</label>
      <select
        name="provincia"
        id=""
        style={{ padding: '10px', borderRadius: '5px' }}
        onChange={handleProvincia}
      >
        <option value="">Seleccionar Provincia</option>
        {props.provinciasAPI.map((provincia) => (
          <option key={provincia.idProvincia} value={provincia.nombre}>
            {provincia.nombre}
          </option>
        ))}
      </select>

      <label htmlFor="">Ciudad</label>
      <select
        name=""
        id=""
        style={{ padding: '10px', borderRadius: '5px' }}
        onChange={handleChangeLocalidad}
      >
        {state.localidadesAPI.map((localidad, index) => (
          <option key={index} value={localidad}>
            {localidad}
          </option>
        ))}
      </select>

      <label htmlFor="">Código Postal</label>
      <Input
        type="text"
        name="cp"
        value={state.cp}
        onChange={handleChange}
        className="input-text-bordered"
        placeholder="Ingrese CP"
        errores={errores}
      />

      <label htmlFor="">Anotaciones para entrega</label>
      <textarea
        type="text"
        name="anotaciones"
        value={state.anotaciones}
        onChange={handleChange}
        className="input-text-bordered anotaciones"
        placeholder="Anotaciones para entrega"
      />

      <div className="text-center w-100 mb-2 gap-2 d-flex justify-content-center">
        <button
          id="btnCancelar"
          onClick={(e) =>
            handleSubmit(e, props.accionCancelar ? props.accionCancelar : 'cancelar')
          }
          className="btn btn-enviar w-30"
        >
          Cancelar
        </button>
        <button
          id="btnGuardar"
          onClick={(e) => handleSubmit(e, 'grabar')}
          className="btn btn-volver-comprar w-30"
        >
          Guardar
        </button>
      </div>
    </form>
  )
}

FormInsertDomicilio.propTypes = {
  Validador: PropTypes.object.isRequired,
  domicilioPrincipal: PropTypes.bool.isRequired,
  domicilioFacturacion: PropTypes.bool.isRequired,
  onNew: PropTypes.func.isRequired,
  onChangeDomicilio: PropTypes.func.isRequired,
  provinciasAPI: PropTypes.array.isRequired,
  accionCancelar: PropTypes.string,
  onCancel: PropTypes.func
}

export default withValidador(FormInsertDomicilio)
